export const generatePermissions = (
  modulePermissionArray: any[],
  permissionConstants: Record<string, string>
) => {
  const permissions: Record<string, boolean> = {};

  Object.keys(permissionConstants).forEach((key) => {
    permissions[key] = false;
  });

  modulePermissionArray.forEach(
    ({ parentModuleIndex, moduleIndex, permissionIndex }) => {
      const key = `${parentModuleIndex}-${moduleIndex}-${permissionIndex}`;
      if (Object.prototype.hasOwnProperty.call(permissions, key)) {
        permissions[key] = true;
      }
    }
  );

  return permissions;
};
